export default __webpack_public_path__ + "static/media/AndriyK280.b4f949b7.jpg";